import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTopMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronTopMedium"><Path d="M5.5 14.5L12 8L18.5 14.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChevronTopMedium;
